<div class="truckJourneyLoadAssignment">
    <app-data-filters #dataFilters [opened]="true" [fullWidth]="true"
                      [disableSearch]="(isLoading | async) || !searchValidity.isValid"
                      [titleKey]="'truck-journeys.load-assignment.filter.search'"
                      [helper]="!searchValidity.isValid"
                      [helperKey]="searchValidity.messageKey"
                      [helperColor]="searchValidity.color"
                      [helperSide]="HelperPosition.RIGHT">
        <app-data-filter-group [useAvailableWidth]="true">
            <app-data-filter-input [labelKey]="'truck-journeys.load-assignment.filter.load-number'"
                                   [(model)]="filters.loadNumber">
            </app-data-filter-input>
            <app-data-filter-input [labelKey]="'truck-journeys.load-assignment.filter.delivery-sales-order-number'"
                                   [(model)]="filters.deliveryNumber">
            </app-data-filter-input>
            <app-data-filter-date [labelKey]="'truck-journeys.load-assignment.filter.appointment-planned-between'"
                                  [(model)]="filters.appointmentPlannedFrom"
                                  (modelChange)="checkSearchValidity('appointmentPlannedFrom')"
                                  [minDate]="yesterday"
                                  [maxDate]="filters.appointmentPlannedTo"
                                  [required]="true">
            </app-data-filter-date>
            <app-data-filter-date [labelKey]="'truck-journeys.load-assignment.filter.appointment-planned-and'"
                                  [(model)]="filters.appointmentPlannedTo"
                                  (modelChange)="checkSearchValidity('appointmentPlannedTo')"
                                  [minDate]="filters.appointmentPlannedFrom"
                                  [required]="true">
            </app-data-filter-date>
            <app-data-filter-select [labelKey]="'truck-journeys.load-assignment.filter.assignment-status.label'"
                                    [(model)]="filters.assignmentStatus"
                                    [options]="assignmentStatusOptions"
                                    [required]="true">
            </app-data-filter-select>
            <app-data-filter-input [labelKey]="'truck-journeys.load-assignment.filter.vehicle'"
                                   [(model)]="filters.vehicle">
            </app-data-filter-input>
        </app-data-filter-group>
        <app-data-filter-group [useAvailableWidth]="true">
            <app-data-filter-multi-string-input
                [labelKey]="'truck-journeys.load-assignment.filter.loading-locations'"
                [placeholderKey]="'truck-journeys.list.filter.loading-locations-placeholder'"
                [(model)]="filters.pickLocationGlids">
            </app-data-filter-multi-string-input>
            <app-data-filter-multi-string-input
                [labelKey]="'truck-journeys.load-assignment.filter.unloading-locations'"
                [placeholderKey]="'truck-journeys.list.filter.loading-locations-placeholder'"
                [(model)]="filters.dropLocationGlids">
            </app-data-filter-multi-string-input>
        </app-data-filter-group>
    </app-data-filters>

    <div class="ibox">
        <div class="ibox-content">
            <div class="flex-row truckJourneyLoadAssignment-head">
                <div class="flex-auto flex-row">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" [name]="'all-loads-selected'"
                                   [(ngModel)]="allLoadschecked"
                                   (ngModelChange)="selectOrUnselectAllLoads()">
                            <i class="fa checkbox-icon"></i>
                        </label>
                    </div>
                    <span [i18n]="[{target: 'innerHTML', key: 'truck-journeys.load-assignment.loads-selected-and-loads-searched',
                params: { nbSelected: numberOfSelectedLoads, nbSearched: selectableLoads?.length || 0 }}]"></span>
                </div>
                <div *ngIf="selectionHasAlreadyAssignedLoad"
                     style="margin-left: 24px;"
                     class="truckJourneyLoadAssignment-callout">
                    <i class="fa fa-warning"></i>
                    <h3 [i18n]="'truck-journeys.load-assignment.already-assigned-load-selected'"></h3>
                </div>
            </div>
            <div *ngIf="selectableLoads.length > 0" class="truckJourneyLoadAssignment-container">
                <div *ngFor="let selectableLoad of selectableLoads" class="truckJourneyLoadAssignment-line">
                    <div class="truckJourneyLoadAssignment-line-checkbox checkbox">
                        <label>
                            <input type="checkbox" [name]="'load-'+selectableLoad.loadId"
                                   [(ngModel)]="selectableLoad.checked"
                                   (ngModelChange)="recalculateSelectedResults()">
                            <i class="fa checkbox-icon"></i>
                        </label>
                    </div>
                    <div class="truckJourneyLoadAssignment-line-load" [class._selected]="selectableLoad.checked">
                        <app-truck-journey-load [truckJourneyLoad]="selectableLoad"
                                                [editableLoad]="false"
                                                [deletableLoad]="false"
                                                [isAssignmentLoad]="true">
                        </app-truck-journey-load>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
